import {appAPI} from "../../../api";
import {INewMaintenanceTemplate, IUpdateMaintenanceTemplate} from "../../../models/IMaintenance";

const basePath = `/maintenance-templates`;
const tasksPath = `/machinery-task`;
/* ──────────────────────────────────────────────────────────────────────────
 * Нормализация payload
 * ────────────────────────────────────────────────────────────────────────── */

const normalize = (
    dto: Partial<INewMaintenanceTemplate>,
): Partial<INewMaintenanceTemplate> => {
    const out: Partial<INewMaintenanceTemplate> = {};

    if (dto.title !== undefined) out.title = String(dto.title).trim();
    if (dto.is_active !== undefined) out.is_active = dto.is_active;

    if (dto.description !== undefined) {
        const desc =
            typeof dto.description === "string"
                ? dto.description.trim()
                : "";
        if (desc) out.description = desc;
    }

    return out;
};

/* ──────────────────────────────────────────────────────────────────────────
 * API
 * ────────────────────────────────────────────────────────────────────────── */

export const maintenanceAPI = {
    // ── Шаблоны регламентов ───────────────────────────────────────────────

    /** Все шаблоны компании */
    getAll: async () => {
        const res = await appAPI.get(basePath);
        return res.data;
    },

    /** Только активные (для селекта в форме задачи) */
    getActive: async () => {
        const res = await appAPI.get(`${basePath}/active`);
        return res.data;
    },

    /** Один шаблон по id */
    getById: async (id: string) => {
        const res = await appAPI.get(`${basePath}/${id}`);
        return res.data;
    },

    getMaintenanceTasks: async () => {
        const res = await appAPI.get(`${tasksPath}/maintenance`);
        return res.data;
    },

    /** Задачи ТО конкретной машины */
    getMaintenanceTasksByMachinery: async (machinery_id: string) => {
        const res = await appAPI.get(`${tasksPath}/maintenance/by_machinery/${machinery_id}`);
        return res.data;
    },

    /** Создать шаблон */
    create: async (dto: INewMaintenanceTemplate) => {
        const res = await appAPI.post(basePath, normalize(dto));
        return res.data;
    },

    /** Обновить шаблон */
    update: async (id: string, dto: IUpdateMaintenanceTemplate) => {
        const res = await appAPI.patch(`${basePath}/${id}`, normalize(dto));
        return res.data;
    },

    /** Удалить шаблон */
    delete: async (id: string) => {
        const res = await appAPI.delete(`${basePath}/${id}`);
        return res.data;
    },

    // ── Дашборд ТО ────────────────────────────────────────────────────────

    /** Таблица машин с данными о ТО */
    getDashboard: async () => {
        const res = await appAPI.get(`${basePath}/dashboard`);
        return res.data;
    },
};